import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import isAuth from './middleware/isAuth'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/menu',
        name: 'menu',
        component: () => import('../views/MenuView.vue'),
        meta: {
            middleware: [isAuth]
        }
    },
    {
        path: '/tracker',
        name: 'tracker',
        component: () => import('../views/TrackerView.vue'),
        meta: {
            middleware: [isAuth]
        }
    },
    {
        path: '/trains',
        name: 'trains',
        component: () => import('../views/TrainsView.vue'),
        meta: {
            middleware: [isAuth]
        }
    },
    {
        path: '/manual',
        name: 'manual',
        component: () => import('../views/ManualView.vue'),
        meta: {
            middleware: [isAuth]
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
